import { LoadingButton } from "@mui/lab";
import { Card, CardActions, CardContent, CardHeader, Divider, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export default function ChooseAutomaticManual({
    name,
    currentValue,
    onConfirm,
    loading,
    isSuccess,
    error,
    title,
    description
}) {
    const { t } = useTranslation()
    const [value, setValue] = useState('');

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    useEffect(() => {
        if (!!currentValue) {
            setValue(currentValue)
        }
    }, [currentValue])

    return (
        <Card>
            <CardHeader title={title} />
            <Divider />
            <CardContent>
                {description}
                <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name={name}
                    value={value}
                    onChange={handleChange}
                >
                    <FormControlLabel value="AUTOMATIC" control={<Radio />} label={t("Automatically")} />
                    <FormControlLabel value="MANUAL" control={<Radio />} label={t("Manually")} />
                </RadioGroup>
            </CardContent>
            <Divider />
            <CardActions sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: 'row-reverse' }}>
                <LoadingButton
                    variant="contained"
                    loading={loading}
                    onClick={() => onConfirm({ [name]: value })}
                    disabled={value === currentValue || (!value && !currentValue)}
                >{t("Confirm")}
                </LoadingButton>
                {isSuccess && <Typography color="success.main">{t("Updated successfully")}</Typography>}
                {error && <Typography color="error.main">{t(error)}</Typography>}
            </CardActions>
        </Card>
    )
}
